import React, { useEffect, useState } from "react";

export default function AlbiCartNotice() {
    const [notice, setNotice] = useState(null);

    useEffect(() => {
        let timer;
        const onResult = (event) => {
            const detail = event?.detail;
            if (!detail?.message) return;
            setNotice({ ok: detail.ok !== false, message: detail.message });
            clearTimeout(timer);
            timer = setTimeout(() => setNotice(null), 2800);
        };
        window.addEventListener("albi-cart-result", onResult);
        return () => {
            clearTimeout(timer);
            window.removeEventListener("albi-cart-result", onResult);
        };
    }, []);

    if (!notice) return null;

    return (
        <div
            role="status"
            style={{
                position: "fixed",
                top: "16px",
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10000,
                maxWidth: "90vw",
                padding: "12px 16px",
                background: notice.ok ? "#111" : "#8a1c1c",
                color: "#fff",
                fontSize: "14px",
                lineHeight: 1.4,
            }}
        >
            {notice.message}
        </div>
    );
}
